<template>
  <div class="columns is-multiline">
    <div class="column is-4">
      <span class="has-text-default is-italic"> {{$t('detailClient.divers.codeMagasin')}} </span>
      <span class="has-text-default has-text-weight-semibold"> {{client.codeMagasin}} </span>
    </div>
    <div class="column is-4">
      <span class="has-text-default is-italic"> {{$t('detailClient.divers.typePointVente')}} </span>
      <span class="has-text-default has-text-weight-semibold">
        {{client.typePointVente ? client.typePointVente.libelle : '' }}
      </span>
    </div>
    <div v-if="moduleFactorActive" class="column is-4">
      <span class="has-text-default is-italic"> {{$t('detailClient.divers.codeMandataire')}} </span>
      <span class="has-text-default has-text-weight-semibold"> {{client.numeroCedant}} </span>
    </div>
    <div class="column is-4">
       <span class="has-text-default is-italic">
        {{$t('detailClient.divers.refExterne')}}
       </span>
       <span class="has-text-default has-text-weight-semibold"> {{client.referenceExterne}} </span>
    </div>
    <div class="column is-4">
       <span class="has-text-default is-italic">
        {{$t('detailClient.divers.dateAnniversaireContrat')}}
       </span>
       <span class="has-text-default has-text-weight-semibold">
          {{ formatDate(client.dateAnniversaireContrat) }}
        </span>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatDate';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleFactorActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleFactor.key);
    },
  },
  methods: {
    formatDate(date) {
      return formatDate(date);
    },
  },
};
</script>
